import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AccountInputSearch from "../../../../commons/components/AccountInputSearch";
import AccountButtonAdd from "../../../../commons/components/AccountButtonAdd";

import {
    usersSetSearchPartner,
    usersSetModePartnerModal,
    usersSetShowPartnerModal,
} from "../../../../store/actions/usersActions";
import partnerModalModes from "../PartnerModal/partnerModalModes";

import { RowFilters, ColFields, ColButtons } from './cardSearchStyles';

function CardSearch(props) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { searchPartner } = useSelector(state => state.users);
    const [permissions] = useState([]);

    const [searchPartnerValue, setSearchPartnerValue] = useState(searchPartner);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(func => {
                        permissions.push(func)
                    })
                }
            });
        }
    }, [screens]);

    function handleInsertPartner() {
        dispatch(usersSetModePartnerModal(partnerModalModes.INSERT));
        dispatch(usersSetShowPartnerModal(true));
    }

    function handleOnSearchPartner(search) {
        dispatch(usersSetSearchPartner(search));
    }

    function handleOnChangePartner(input) {
        setSearchPartnerValue(input.target.value);
    }

    function renderButtons() {
        return (
            <AccountButtonAdd
                label="Novo parceiro"
                onClick={handleInsertPartner}
            />
        )
    }

    return (
        <RowFilters>
            <ColFields flex="auto">
                <AccountInputSearch
                    value={searchPartnerValue}
                    placeholder="Pesquisar parceiro"
                    style={{ width: 300, marginRight: 6 }}
                    onSearch={handleOnSearchPartner}
                    onChange={handleOnChangePartner}
                />
            </ColFields>
            <ColButtons>
                {renderButtons()}
            </ColButtons>
        </RowFilters>
    )
}

export default CardSearch;
